module.exports = "┏━━━━━┓\n┣━━┳━━┫\n┃╱╱┃╱╱┃\n┃╱╱┃╱╱┃\n┃╱╱┃╱╱┃\n┗━━┻━━┛\n";


//////////////////
// WEBPACK FOOTER
// ./src/templates/2cols/2cols.preview.html
// module id = 283
// module chunks = 0